// extracted by css-extract-rspack-plugin
export default {"SettingLabel":"cfJ_9","SettingLabelError":"Zdw0t","SettingValueWidget":"VTmcJ"};